/**
 * A class representing the information about the attachments section
 */
export class AttachmentsInfo {
    /**
     *
     * @param {Attachment[]} mainAttachments
     * @param {Attachment[]} competitiveBiddingJustificationAttachments
     * @param {string} aribaID
     * @param {string} cbFormID
     * @param {boolean} exception
     * @param {string} selectedException
     * @param {string} complianceIndicator
     */
    constructor(
        mainAttachments,
        competitiveBiddingJustificationAttachments,
        aribaID,
        cbFormID,
        exception,
        selectedException,
        complianceIndicator,
    ) {
        this._mainAttachments = mainAttachments;
        this._competitiveBiddingJustificationAttachments = competitiveBiddingJustificationAttachments;
        this._aribaID = aribaID;
        this._cbFormID = cbFormID;
        this._exception = exception;
        this._selectedException = selectedException;
        this._complianceIndicator = complianceIndicator;
    }

    /**
     * Get all the information about and AttachmentsInfo object, in a JS object
     * @return {{exception: boolean, mainAttachments: {date: string, file: string, name: string, topic: string, user: string}[], cbFormID: string, selectedException: string, aribaId: string, competitiveBiddingJustificationAttachments: {date: string, file: string, name: string, topic: string, user: string}[]}}
     */
    getAttachmentsInfo() {
        return {
            mainAttachments: this._mainAttachments.map((attachment) => attachment.getAttachment()),
            competitiveBiddingJustificationAttachments: this._competitiveBiddingJustificationAttachments.map((attachment) => attachment.getAttachment()),
            aribaId: this._aribaID,
            cbFormID: this._cbFormID,
            exception: this._exception,
            selectedException: this._selectedException,
            complianceIndicator: this._complianceIndicator,
        };
    }

    /**
     * Get the mainAttachments value.
     * @return {Attachment[]} The mainAttachments value.
     */
    get mainAttachments() {
        return this._mainAttachments;
    }

    /**
     * Set the mainAttachments value.
     * @param {Attachment[]} value to set
     */
    set mainAttachments(value) {
        this._mainAttachments = value;
    }

    /**
     * Get the competitiveBiddingJustificationAttachments value.
     * @return {Attachment[]} The competitiveBiddingJustificationAttachments value.
     */
    get competitiveBiddingJustificationAttachments() {
        return this._competitiveBiddingJustificationAttachments;
    }

    /**
     * Set the competitiveBiddingJustificationAttachments value.
     * @param {Attachment[]} value to set
     */
    set competitiveBiddingJustificationAttachments(value) {
        this._competitiveBiddingJustificationAttachments = value;
    }

    /**
     * Get the aribaID value.
     * @return {string} The aribaID value.
     */
    get aribaID() {
        return this._aribaID;
    }

    /**
     * Set the aribaID value.
     * @param {string} value to set
     */
    set aribaID(value) {
        this._aribaID = value;
    }

    /**
     * Get the cbFormID value.
     * @return {string} The cbFormID value.
     */
    get cbFormID() {
        return this._cbFormID;
    }

    /**
     * Set the cbFormID value.
     * @param {string} value to set
     */
    set cbFormID(value) {
        this._cbFormID = value;
    }

    /**
     * Get the exception value.
     * @return {boolean} The exception value.
     */
    get exception() {
        return this._exception;
    }

    /**
     * Set the exception value.
     * @param {boolean} value to set
     */
    set exception(value) {
        this._exception = value;
    }

    /**
     * Get the selectedException value.
     * @return {string} The selectedException value.
     */
    get selectedException() {
        return this._selectedException;
    }

    /**
     * Set the selectedException value.
     * @param {string} value to set
     */
    set selectedException(value) {
        this._selectedException = value;
    }

    /**
     * Get the complianceIndicator value.
     * @return {string} The complianceIndicator value.
     */
    get complianceIndicator() {
        return this._complianceIndicator;
    }

    /**
     * Set the complianceIndicator value.
     * @param {string} value to set
     */
    set complianceIndicator(value) {
        this._complianceIndicator = value;
    }
}
